export const weightUnitOptions = [
  {
    value: "kg",
    label: "Kg",
  },
  {
    value: "lbs",
    label: "Lbs",
  },
];

export const dimensionUnitOptions = [
  {
    value: "meter",
    label: "Meters",
  },
  {
    value: "feet",
    label: "Feet",
  },
];
